import { useGetCurrentUser } from 'gcs-common/clients/api/entities/current-user/current-user-api';
import UserCodeEmailForm from 'gcs-common/components/UserCodeForm/UserCodeEmailForm/UserCodeEmailForm';
import UserCodePhoneForm from 'gcs-common/components/UserCodeForm/UserCodePhoneForm/UserCodePhoneForm';
import { CHAT_ROUTES } from 'gcs-common/constants/routes';
import { useQueryParams } from 'gcs-common/design-system/hooks/use-query-params';
import { Navigate } from 'react-router';

const RequestUserCode = () => {
  const { queryParams } = useQueryParams(['method']);
  const { method } = queryParams;

  const { isSuccess } = useGetCurrentUser();

  if (isSuccess) {
    return <Navigate to={CHAT_ROUTES.CHAT} replace />;
  }

  return method === 'phone' ? <UserCodePhoneForm /> : <UserCodeEmailForm />;
};

export default RequestUserCode;
